export const loadOneTrust = () => {
  return new Promise((resolve, reject) => {
    const oneTrustId = import.meta.env.VITE_ONETRUST;
    const scriptSrc = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';

    if (!oneTrustId) {
      reject(new Error('OneTrust ID not configured'));
      return;
    }

    if (document.querySelector(`script[src="${scriptSrc}"]`)) {
      resolve('OneTrust already loaded');
      return;
    }

    const script = document.createElement('script');
    script.src = scriptSrc;
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.dataset.domainScript = oneTrustId;

    script.onload = () => {
      if (!window.OptanonWrapper) {
        window.OptanonWrapper = function () {};
      }
      resolve('OneTrust loaded successfully');
    };

    script.onerror = () => {
      reject(new Error('Failed to load OneTrust script'));
    };

    document.head.appendChild(script);
  });
};
